"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDocumentType = void 0;
var OrderDocumentType;
(function (OrderDocumentType) {
    OrderDocumentType["CUSTOMER_INVOICE"] = "customer_invoice";
    OrderDocumentType["CUSTOMER_CREDIT_NOTE"] = "customer_credit_note";
    OrderDocumentType["TRADER_INVOICE"] = "trader_invoice";
    OrderDocumentType["TRADER_CREDIT_NOTE"] = "trader_credit_note";
    OrderDocumentType["QUOTE"] = "quote";
})(OrderDocumentType = exports.OrderDocumentType || (exports.OrderDocumentType = {}));
//# sourceMappingURL=document.js.map